import { render, staticRenderFns } from "./tab_media_konvensional.vue?vue&type=template&id=1999bf84"
import script from "./tab_media_konvensional.vue?vue&type=script&lang=js"
export * from "./tab_media_konvensional.vue?vue&type=script&lang=js"
import style0 from "./tab_media_konvensional.vue?vue&type=style&index=0&id=1999bf84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports